type SignedUploadClient = {
  put: (
    url: string,
    data: File,
    config: { headers: { 'Content-Type': string } },
  ) => Promise<unknown>;
};

/**
 * Sends a file to a signed object-storage URL while preserving its MIME type.
 * The API validates the stored content type before promoting temporary uploads.
 */
export const uploadToSignedUrl = (
  client: SignedUploadClient,
  url: string,
  file: File,
) => client.put(url, file, {
  headers: {
    'Content-Type': file.type || 'application/octet-stream',
  },
});
